import { useContext, useState } from 'react';
import { UserContext } from '../../../../../Context/UserContext/UserContext';
// import { useComplianceSession } from '../../../../../Context/ComplianceSessionContext';

interface ILawData {
  id: number;
  name: string;
}

export const useComplianceState = () => {
  // const { createComplianceSession } = useComplianceSession();
  const { complianceUserFor } = useContext(UserContext);

  const [lawsSelectedForCompliance, setLawsSelectedForCompliance] = useState<ILawData[]>([]);
  const [enabled, setEnabled] = useState<boolean>(false);
  const hasCompliance = (predicate: (law: ILawData) => boolean) => lawsSelectedForCompliance.some(predicate);

  const toggleCompliance = (row: ILawData) => {
    if (hasCompliance((x) => x.id === row.id)) {
      setLawsSelectedForCompliance(lawsSelectedForCompliance.filter((x) => x.id !== row.id));
    } else {
      setLawsSelectedForCompliance([...lawsSelectedForCompliance, row]);
    }
  };

  const startComplianceSession = () => {
    if (lawsSelectedForCompliance.length > 0) {
      // const session = createComplianceSession(lawsSelectedForCompliance);
      // setEnabled(false);
      // setLawsSelectedForCompliance([]);
      // history.push(session.todo[0].complianceUrl);
    }
  };

  return {
    enableCompliance: complianceUserFor.laws.length > 0 ? () => setEnabled(true) : undefined,
    disableCompliance: () => setEnabled(false),
    complianceEnabled: enabled,
    toggleCompliance,
    startComplianceSession,
    hasCompliance,
    isComplianceUserFor: (lawId: number) => complianceUserFor.laws.some((x) => x.id === lawId),
  };
};
